// src/pages/Admin/Dashboard/Events/components/EventsToolbar.jsx

import React from "react";
import { FaPlus, FaSearch, FaSyncAlt } from "react-icons/fa";

export default function EventsToolbar({
  loading,
  filters,
  setFilter,
  totalCount,
  filteredCount,
  onCreate,
  onRefresh,
}) {
  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
        <div>
          <h2 className="text-lg font-bold text-slate-950 dark:text-white">
            Liste des événements
          </h2>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            {filteredCount} événement{filteredCount > 1 ? "s" : ""} affiché
            {filteredCount > 1 ? "s" : ""} sur {totalCount}.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={onCreate}
            className="inline-flex items-center gap-2 rounded-2xl bg-slate-950 px-4 py-2.5 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-slate-800 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-200"
          >
            <FaPlus />
            Créer
          </button>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:bg-slate-50 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <FaSyncAlt className={loading ? "animate-spin" : ""} />
            Actualiser
          </button>
        </div>
      </div>

      <div className="mt-5 grid gap-3 xl:grid-cols-[minmax(0,1.4fr)_180px_210px_210px]">
        <label className="relative block">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="search"
            value={filters.query}
            onChange={(event) => setFilter("query", event.target.value)}
            placeholder="Rechercher un titre, lieu, catégorie, description..."
            className="w-full rounded-2xl border border-slate-200 bg-slate-50 py-3 pl-11 pr-4 text-sm text-slate-700 outline-none transition focus:border-blue-400 focus:bg-white focus:ring-4 focus:ring-blue-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-blue-500/10"
          />
        </label>

        <select
          value={filters.status}
          onChange={(event) => setFilter("status", event.target.value)}
          className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-blue-400 focus:bg-white focus:ring-4 focus:ring-blue-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-blue-500/10"
        >
          <option value="all">Tous les statuts</option>
          <option value="active">Actifs</option>
          <option value="inactive">Inactifs</option>
        </select>

        <select
          value={filters.registration}
          onChange={(event) => setFilter("registration", event.target.value)}
          className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-blue-400 focus:bg-white focus:ring-4 focus:ring-blue-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-blue-500/10"
        >
          <option value="all">Toutes inscriptions</option>
          <option value="open">Inscriptions ouvertes</option>
          <option value="closed">Inscriptions fermées</option>
        </select>

        <select
          value={filters.sortOrder}
          onChange={(event) => setFilter("sortOrder", event.target.value)}
          className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-blue-400 focus:bg-white focus:ring-4 focus:ring-blue-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-blue-500/10"
        >
          <option value="start_asc">Date croissante</option>
          <option value="start_desc">Date décroissante</option>
          <option value="title_asc">Titre A → Z</option>
          <option value="title_desc">Titre Z → A</option>
        </select>
      </div>
    </section>
  );
}